import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { products } from "@/data/products";
import { productPath } from "@/lib/seo";

export const Products = () => {
  return (
    <section id="products" className="relative py-24 md:py-32">
      <div className="container">
        <div className="max-w-2xl mb-16">
          <p className="font-mono text-xs uppercase tracking-widest text-primary mb-4">Our Products</p>
          <h2 className="font-display text-3xl md:text-5xl font-bold leading-tight">
            Six products. One enterprise-grade platform.
          </h2>
          <p className="mt-4 text-muted-foreground text-lg">
            Elegant, weightless products running at your core, delivering real-time KPIs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {products.map((p) => (
            <article
              key={p.slug}
              className="group relative flex flex-col rounded-2xl border border-border bg-card-gradient p-7 transition-all duration-300 hover:border-primary/40 hover:-translate-y-1 hover:shadow-elevated"
            >
              <div className={`inline-flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br ${p.accent} mb-6`}>
                <img src={p.icon} alt={p.alt} width={36} height={36} className="h-9 w-9" />
              </div>

              <h3 className="font-display text-2xl font-bold">{p.name}<span className="text-primary">®</span></h3>
              <p className="text-sm text-muted-foreground mt-1 mb-6">{p.tagline}</p>

              <div className="mt-auto pt-5 border-t border-border">
                <Button variant="ghost-glow" size="sm" asChild>
                  <a href={productPath(p.slug)} data-umami-event="product_learn_more" data-umami-event-product={p.slug}>
                    Learn more<span className="sr-only"> about {p.name}</span> <ArrowUpRight className="ml-1.5 h-3.5 w-3.5" />
                  </a>
                </Button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
